import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import CircularProgress from "@mui/material/CircularProgress";
import { PrimaryText } from "@components";
import { getSelectedPlayerData, allCompetitions } from "@store";
import userProfile from "@assets/image/userProfile.jpg";
import "../../containerStyle.css";
import ReadMore from "../../../components/readMore";

function CompetitionCard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const allCompetitionsData = useSelector(
    (state) => state.competition?.allCompetitions
  );

  const [state, setState] = useState({
    loader: false,
    confirmId: null,
    loading: false,
    is_Active: false,
  });

  useEffect(() => {
    setState((prev) => ({ ...prev, loading: true }));
    dispatch(allCompetitions()).then((res) => {
      setState((prev) => ({ ...prev, loading: false }));
      const t_Data = res?.payload?.data?.data;
      if (t_Data?.length) {
        const active_Tournamnet = t_Data.find((e, i) => {
          return e?.TournamentStatus === "active";
        });
        if (active_Tournamnet) {
          setState((prev) => ({ ...prev, is_Active: true }));
        } else {
          setState((prev) => ({ ...prev, is_Active: false }));
        }
      }
    });
  }, [dispatch]);

  const goTournament = (e) => {
    setState((prev) => ({ ...prev, loader: true, confirmId: e?.id }));
    localStorage.removeItem("AddToCartsData");
    dispatch(getSelectedPlayerData({ save: false }));
    navigate(`/tournament/${e?.id}/open-competition`);
    window.scrollTo(0, 0);
  };

  const ShowMessage = (props) => {
    return (
      <div className="w-full h-full flex justify-center items-center my-[20px]">
        <PrimaryText
          className={"center text-xl text-white255 animate-pulse text-center "}
        >
          {props.title}
        </PrimaryText>
      </div>
    );
  };

  return (
    <>
      {allCompetitionsData?.length > 0 && state.is_Active === true && (
        <CompetitionView>
          <PrimaryText className="text-3xl text-white255 font-bold font-[Cambay] text-center">
            {t("competition.seeOur")}
          </PrimaryText>
          <PrimaryText className="text-md leading-tight text-white255 font-[Cambay] text-center mt-[6px]">
            {t("competition.clickOn")}
          </PrimaryText>
        </CompetitionView>
      )}

      {state.loading ? (
        <div className="flex h-full w-full pt-[70px] pb-[70px] justify-center">
          <CircularProgress sx={{ color: "#ffffff" }} size={50} thickness={5} />{" "}
        </div>
      ) : !state.is_Active ? (
        <ShowMessage title={t("competition.noCompetion")} />
      ) : allCompetitionsData?.length ? (
        allCompetitionsData?.map((item, index) => (
          <React.Fragment key={`competitions${index}`}>
            {item?.TournamentStatus === "active" ? (
              <div className="w-full h-auto rounded-lg ">
                <Component onClick={() => goTournament(item)}>
                  <div className={detailView}>
                    <div className={img_view}>
                      <img
                        src={
                          item?.image?.url ? `${item?.image?.url}` : userProfile
                        }
                        alt="img"
                        className="w-full min-w-[70px] min-h-[70px] h-auto border border-[#969696] rounded-md"
                      />
                    </div>
                    <div className="w-fit pl-[20px]">
                      <PrimaryText className={title_txt}>
                        {item?.title?.charAt(0).toUpperCase() +
                          item?.title?.slice(1)}
                      </PrimaryText>
                      <br />
                      {item?.description ? (
                        <ReadMore text={item?.description} limit={340} />
                      ) : (
                        <></>
                      )}
                      <br />
                      {item?.holes && (
                        <PrimaryText className={hole_txt}>
                          {item?.holes + t("tournament.Holes")}
                        </PrimaryText>
                      )}
                    </div>
                  </div>
                  {item?.tournaments[0]?.courseId?.courseName && (
                    <CourseView>
                      <PrimaryText className="text-md text-textColor2 font-semibold font-[Cambay] px-2">
                        {t("competition.course") +
                          item?.tournaments[0]?.courseId?.courseName}
                      </PrimaryText>
                    </CourseView>
                  )}
                </Component>
              </div>
            ) : (
              <></>
            )}
          </React.Fragment>
        ))
      ) : (
        <ShowMessage title={t("competition.noCompetion")} />
      )}
    </>
  );
}

const Component = tw.div`
h-auto
min-h-[90px]
w-full
flex
flex-wrap
gap-x-[3px] gap-y-4
items-center
justify-between
bg-white
mt-4
mb-2
px-4
pb-2
pt-5
rounded-lg
hover:cursor-pointer
hover:opacity-80
`;
const CompetitionView = tw.div`
w-full 
h-auto 
flex flex-col 
justify-between items-center
`;
const detailView = `
w-auto 
h-auto 
flex 
flex-row 
items-start 
justify-start
`;
const CourseView = tw.div`
w-auto
h-auto
flex 
items-center 
justify-center 
rounded-sm
`;
const img_view = `
md:w-[75px] sm:w-[65px] w-[65px] 
md:h-[65px] sm:h-[55px] h-[55px] 
min-w-[65px] max-w-[75px] 
min-h-[55px] max-h-[65px] 
ms-2
flex
`;
const title_txt = `
font-[Cambay] 
text-[18px]
mb-2
font-semibold 
`;

const hole_txt = `
text-md 
font-[Cambay] 
leading-3 
text-[#969696]
`;

export default CompetitionCard;
